import { PagingData } from "./paging.types";
import { FilterRule } from "@/models/filter-rule";

export class Paging implements PagingData {
  readonly from: number;
  readonly to: number;
  readonly size: number;
  readonly sortBy: string;
  readonly sortReverse: boolean;
  readonly filter?: FilterRule;

  constructor(data: PagingData) {
    this.from = data.from;
    this.to = data.to;
    this.size = data.size;
    this.sortBy = data.sortBy;
    this.sortReverse = data.sortReverse;

    if (data.filter) {
      this.filter = new FilterRule(data.filter!);
    }
  }
}
